<template>
  <header class="navbar">
    <div class="container">
      <div class="navbar-brand">
        <img src="../assets/images/logo.svg" alt="汉语基础平台" class="logo" />
        <span class="brand-name">汉语基础平台</span>
      </div>
      <nav class="navbar-menu" :class="{ 'is-active': isMenuActive }">
        <a href="#mission" class="nav-link">
          <i class="fas fa-bullseye"></i>
          <span>平台使命</span>
        </a>
        <a href="#value" class="nav-link">
          <i class="fas fa-gem"></i>
          <span>核心价值</span>
        </a>
        <a href="#capabilities" class="nav-link">
          <i class="fas fa-brain"></i>
          <span>核心能力</span>
        </a>
        <a href="#scenarios" class="nav-link">
          <i class="fas fa-industry"></i>
          <span>应用场景</span>
        </a>
        <a href="#architecture" class="nav-link">
          <i class="fas fa-sitemap"></i>
          <span>技术架构</span>
        </a>
        <a href="#cases" class="nav-link">
          <i class="fas fa-trophy"></i>
          <span>成功案例</span>
        </a>
        <a href="#pricing" class="nav-link">
          <i class="fas fa-tags"></i>
          <span>价格方案</span>
        </a>
      </nav>
      <div class="navbar-toggle" @click="toggleMenu">
        <span class="bar"></span>
        <span class="bar"></span>
        <span class="bar"></span>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'NavBar',
  data() {
    return {
      isMenuActive: false
    }
  },
  methods: {
    toggleMenu() {
      this.isMenuActive = !this.isMenuActive
      // 添加动画类
      const toggle = document.querySelector('.navbar-toggle')
      if (this.isMenuActive) {
        toggle.classList.add('is-active')
      } else {
        toggle.classList.remove('is-active')
      }
    },
    closeMenu() {
      this.isMenuActive = false
      document.querySelector('.navbar-toggle').classList.remove('is-active')
    }
  },
  mounted() {
    // 平滑滚动到锚点
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        e.preventDefault()
        const target = document.querySelector(this.getAttribute('href'))
        if (target) {
          target.scrollIntoView({
            behavior: 'smooth'
          })
        }
      })
    })
  }
}
</script>

<style scoped lang="scss">
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  transition: all 0.3s ease;
  
  .container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 70px;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
  }
  
  .navbar-brand {
    order: 1; // 确保品牌在最左侧
  }
  
  .navbar-menu {
    order: 2; // 导航菜单在右侧
  }
  
  .navbar-toggle {
    order: 3; // 汉堡菜单在最右侧
  }
}

.navbar-brand {
  display: flex;
  align-items: center;
  flex-shrink: 0; // 防止收缩
  
  .logo {
    height: 40px;
    margin-right: 12px;
    transition: transform 0.3s ease;
    
    &:hover {
      transform: scale(1.05);
    }
  }
  
  .brand-name {
    font-size: 22px;
    font-weight: 700;
    color: var(--primary-color);
    background: linear-gradient(135deg, #409EFF, #67C23A);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    white-space: nowrap; // 防止文字换行
  }
}

.navbar-menu {
  display: flex;
  
  .nav-link {
    display: flex;
    align-items: center;
    margin-left: 30px;
    color: var(--text-color);
    text-decoration: none;
    font-weight: 500;
    padding: 8px 16px;
    border-radius: 8px;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
    white-space: nowrap; // 防止文字换行
    
    i {
      margin-right: 8px;
      font-size: 16px;
    }
    
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: -100%;
      width: 100%;
      height: 100%;
      background: linear-gradient(90deg, transparent, rgba(64, 158, 255, 0.1), transparent);
      transition: left 0.5s ease;
    }
    
    &:hover {
      color: var(--primary-color);
      background-color: rgba(64, 158, 255, 0.05);
      transform: translateY(-2px);
      
      &::before {
        left: 100%;
      }
      
      i {
        transform: scale(1.1);
      }
    }
  }
}

.navbar-toggle {
  display: none;
  flex-direction: column;
  cursor: pointer;
  padding: 5px;
  
  .bar {
    width: 25px;
    height: 3px;
    background-color: var(--text-color);
    margin: 3px 0;
    transition: 0.3s;
    border-radius: 3px;
  }
  
  &:hover .bar {
    background-color: var(--primary-color);
  }
}

@media (max-width: 768px) {
  .navbar-menu {
    position: fixed;
    left: -100%;
    top: 70px;
    flex-direction: column;
    background-color: var(--white);
    width: 100%;
    text-align: center;
    transition: 0.3s;
    box-shadow: 0 10px 27px rgba(0, 0, 0, 0.05);
    padding: 20px 0;
    
    &.is-active {
      left: 0;
    }
    
    .nav-link {
      margin: 10px 0;
      justify-content: center;
      white-space: nowrap; // 防止文字换行
      
      i {
        margin-right: 10px;
      }
    }
  }
  
  .navbar-toggle {
    display: flex;
    
    &.is-active {
      .bar:nth-child(1) {
        transform: translateY(8px) rotate(45deg);
      }
      
      .bar:nth-child(2) {
        opacity: 0;
      }
      
      .bar:nth-child(3) {
        transform: translateY(-8px) rotate(-45deg);
      }
    }
  }
}
</style>